import { render } from "./AppBarTitle.vue?vue&type=template&id=05722f0d"
import script from "./AppBarTitle.vue?vue&type=script&lang=js"
export * from "./AppBarTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__